import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const GoalGroupModalContainer = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: space-between;
  padding: 40px;
  min-width: fit-content;
  width: 648px;
`
export const Copy = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Header = styled(Typography)`
  ${typography.up2.regularSerif};
`

export const Text = styled(Typography)`
  ${typography.baseline.regularSans};
`

export const ButtonsContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`
